import { gql } from '@apollo/client';
import { USER } from '../fragments';

export const DELETE_TEAM_MEMBER = gql`
  mutation deleteTeamMember($id: ID!) {
    user: deleteUser(where: { id: $id }) {
      ...user
    }
  }
  ${USER}
`;
